import type { FC, ReactNode } from "react";
import {
  AppBar,
  Box,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { ContentTypeType } from "@/types/graphql/partner.generated";
import { PollsPanel } from "./PollsPanel";

interface VideoPollsScreenProps {
  contentId: string;
  onClose: () => void;
  /** Вкладки диалога видео (VideoTabsMenu), как у TimecodesScreen. */
  menu?: ReactNode;
}

export const VideoPollsScreen: FC<VideoPollsScreenProps> = ({
  contentId,
  onClose,
  menu,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AppBar color="default" position="fixed" elevation={0}>
        <Toolbar>
          <IconButton edge="start" onClick={onClose} sx={{ mr: 1 }}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" noWrap sx={{ flex: 1, mr: 1 }}>
            {t("polls.title")}
          </Typography>
        </Toolbar>
        <Divider />
      </AppBar>
      <Box sx={{ mt: { xs: "56px", sm: "64px" } }}>{menu}</Box>
      <Box sx={{ p: 1 }}>
        <PollsPanel
          contentId={contentId}
          contentType={ContentTypeType.VideoType}
        />
      </Box>
    </>
  );
};
